/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Ukrainian (Ukraine)
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'На жаль, нічого не знайдено. Можливо, сторінку було видалено. Якщо, звісно, в URL-адресі немає помилки 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'На жаль, за вашим запитом нічого не знайдено',
  'embedded.confluence.already-logged-in-paragraph': 'Уже ввійшли в систему? Спробуйте оновити сторінку.',
  'embedded.confluence.footer.hover.text': 'Переглянути в Confluence',
  'embedded.confluence.footer.prefix': 'На платформі',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Увійти в Confluence',
  'embedded.confluence.login-page.login-button': 'Увійти в Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Кнопка для входу',
  'embedded.confluence.login-page.login-text': 'Щоб переглянути цю сторінку, потрібно ввійти в систему',
  'embedded.confluence.login-page.refresh-page-banner':
    'Після входу в систему ця сторінка оновлюватиметься автоматично. Якщо ні, ви можете натиснути тут, щоб оновити її',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Оновити сторінку',
  'embedded.confluence.need-to-log-in-paragraph': 'Щоб переглянути цю сторінку, потрібно ввійти в систему',
  'embedded.confluence.still-having-trouble-paragraph':
    'Досі виникають проблеми? Переконайтеся, що сторонні файли cookie ввімкнено, або {link}.',
  'embedded.confluence.troubleshooting-link-text': 'скористайтеся цим посібником з усунення неполадок',
  'embedded.confluence.troubleshooting-link.aria-label': 'посилання на посібник з усунення неполадок',
};
